import { createFileRoute } from "@tanstack/react-router";
import DueDiligenceDepressionTreatment from "@/pages/articles/DueDiligenceDepressionTreatment";
export const Route = createFileRoute(
  "/how-to-do-due-diligence-on-a-depression-treatment",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "How To Do Due Diligence On A Depression Treatment | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How to research a depression treatment provider before you commit. Questions to ask about TMS, SAINT TMS, and credentials in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "How To Do Due Diligence On A Depression Treatment | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How to research a depression treatment provider before you commit. Questions to ask about TMS, SAINT TMS, and credentials in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/how-to-do-due-diligence-on-a-depression-treatment",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-to-do-due-diligence-on-a-depression-treatment",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DueDiligenceDepressionTreatment />;
}
